import React, { useEffect, useState } from "react";
import styles from "./NewMultipleImageUploadComponent.module.scss";
// import { SelectBasicWithSelectTag } from "../SelectMultiSelect/SelectMultiSelect";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import ImageList from "./ImageList";
import DocumentList from "./DocumentList";
import VideoList from "./VideoList";
import { getDecryptedData } from "../../utils/crypto";

const MultipleImageUploadComponent = ({
  modelType,
  modelId,
  upload_collection,
  setState,
  fileTypeDisabled,
  multiple = true,

  // Url type
  urlType,
  tokenType,

  // upload url
  uploadType,

  // delete url
  deleteType,

  // For Agent Only
  file_type_agent,
  // fetchMediaRefetch,
  showSingleImage = false,
}) => {
  const [files, setFiles] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [fileType, setFileType] = useState("image");
  const [showFileType, setShowFileType] = useState("photos");
  const [isUploading, setIsUploading] = useState(false);
  // const vendorToken = localStorage.getItem("token");
  const vendorToken = getDecryptedData("userToken");
  const agentToken = getDecryptedData("userToken");

  // Validate file type
  const validateFileType = (file) => {
    const allowedTypes = {
      image: ["image/jpeg", "image/png"],
      video: ["video/mp4", "video/mov", "video/avi", "video/wmv", "video/mkv"],
      document: ["application/pdf"],
    };
    return allowedTypes[fileType]?.includes(file.type);
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter(validateFileType);

    if (validFiles.length < selectedFiles.length) {
      showErrorToast(
        "Some files are not supported. Please select valid formats."
      );
    }

    const fileDataPromises = validFiles.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve({
            file,
            preview: file.type === "application/pdf" ? null : reader.result,
            name: file.name,
          });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileDataPromises).then((fileData) => {
      setFiles(multiple ? [...files, ...fileData] : fileData);
    });
  };

  // const [
  //   fetchMedia,
  //   {
  //     data: fetchMediaData,
  //     isSuccess: fetchMediaSuccess,
  //     isLoading: fetchMediaLoading,
  //     isError: fetchMediaError,
  //     refetch: fetchMediaRefetch,
  //   },
  // ] = useFetchMediaMutation(modelId, {
  //   skip: !modelId,
  // });

  const fetchMedia = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append(
      "Authorization",
      `Bearer ${tokenType === "agent" ? agentToken : vendorToken}`
    );
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const formdata = new FormData();
    formdata.append("modelType", modelType);
    formdata.append("modelId", modelId);
    formdata.append(
      "upload_collection",
      file_type_agent ? file_type_agent : showFileType
    );

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/${urlType}`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        setImageData(result?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   if (fetchMediaSuccess) {
  //     setImageData(fetchMediaData.data);
  //   }
  // }, [fetchMediaSuccess, fetchMediaData]);

  // console.log("imageData", imageData);

  useEffect(() => {
    if (modelId && showFileType) {
      fetchMedia({
        modelType: modelType,
        modelId: modelId,
        upload_collection: file_type_agent ? file_type_agent : showFileType,
      });
    }
  }, [modelId, showFileType]);

  const handleUpload = async () => {
    if (files.length === 0) {
      showErrorToast("No files to upload!");
      return;
    }

    setIsUploading(true);

    const array = getFieTypeArray(modelType);
    const obj = array.find((item) => item.value === fileType);

    if (!obj) {
      showErrorToast("Invalid file type!");
      setIsUploading(false);
      return;
    }

    try {
      // Set up headers
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${vendorToken}`);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      // Create FormData
      const formData = new FormData();
      formData.append("modelType", modelType);
      formData.append("modelId", modelId);
      formData.append(
        "upload_collection",
        file_type_agent ? file_type_agent : obj.uploadCollection
      );
      formData.append("file_type", fileType);

      files.forEach((fileData) => {
        formData.append("files[]", fileData.file);
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
      };

      // Make the API call
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/${uploadType}`,
        requestOptions
      );

      const result = await response.json();

      if (response.ok && result?.success) {
        showSuccessToast(result.message);
        setFiles([]);
        fetchMedia({
          modelType: modelType,
          modelId: modelId,
          upload_collection: showFileType,
        });
      } else {
        showErrorToast(result?.message || "Upload failed!");
      }
    } catch (error) {
      showErrorToast("An error occurred during upload. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  // Remove a file from the list
  const handleDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const normal = [
    { value: "image", label: "Images", uploadCollection: "photos" },
    { value: "video", label: "Videos", uploadCollection: "videos" },
  ];

  const agent = [
    { value: "image", label: "Agent Logo", uploadCollection: "agent-logo" },
    { value: "document", label: "Documents", uploadCollection: "documents" },
  ];
  const destinations = [
    { value: "image", label: "Images", uploadCollection: "photos" },
    { value: "video", label: "Videos", uploadCollection: "videos" },
  ];
  const packages = [
    { value: "image", label: "Images", uploadCollection: "photos" },
    { value: "video", label: "Videos", uploadCollection: "videos" },
  ];

  const accommodation = [
    { value: "image", label: "Images", uploadCollection: "photos" },
    { value: "video", label: "Videos", uploadCollection: "videos" },
    { value: "document", label: "Document", uploadCollection: "documents" },
  ];

  const normalShow = [
    { value: "photos", label: "Images", uploadCollection: "photos" },
    { value: "videos", label: "Videos", uploadCollection: "videos" },
  ];

  const agentShow = [
    { label: "Agent Logo", value: "agent-logo" },
    { label: "Documents", value: "documents" },
  ];

  const destinationsShow = [
    { value: "photos", label: "Images", uploadCollection: "photos" },
    { value: "videos", label: "Videos", uploadCollection: "videos" },
  ];

  const accommodationShow = [
    { value: "photos", label: "Images", uploadCollection: "photos" },
    { value: "videos", label: "Videos", uploadCollection: "videos" },
    { value: "documents", label: "Document", uploadCollection: "documents" },
  ];
  const packagesShow = [
    { value: "image", label: "Images", uploadCollection: "photos" },
    { value: "video", label: "Videos", uploadCollection: "videos" },
  ];

  const getFieTypeArray = (modelType) => {
    // if (modelType === "agents") {
    //   return agent;
    // } else {
    //   return normal;
    // }

    // with switch
    switch (modelType) {
      case "agents":
        return agent;
      case "destinations":
        return destinations;
      case "accommodation":
        return accommodation;
      case "packages":
        return packages;
      default:
        return normal;
    }
  };

  const getFieTypeArrayShow = (modelType) => {
    // if (modelType === "agents") {
    //   return agent;
    // } else {
    //   return normal;
    // }

    // with switch
    switch (modelType) {
      case "agents":
        return agentShow;
      case "destinations":
        return destinationsShow;
      case "accommodation":
        return accommodationShow;
      case "packagesShow":
        return packagesShow;
      default:
        return normalShow;
    }
  };

  return (
    <div className={styles.multipleImageUpload}>
      {files.length > 0 ? (
        <div>
          <div>Selected Files:</div>
          <div className={styles.previewContainer}>
            {files.map((fileData, index) => (
              <div key={index}>
                {fileType === "image" && (
                  <img
                    className={styles.previewImage}
                    src={fileData.preview}
                    alt={fileData.name}
                    style={{ objectFit: "contain" }}
                  />
                )}
                {fileType === "video" && (
                  <div style={{ width: "200px", height: "200px" }}>
                    <video
                      className={styles.previewVideo}
                      src={fileData.preview}
                      controls
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                )}
                {fileType === "document" && (
                  <div className={styles.documentPreview}>
                    <p>{fileData.name}</p>
                  </div>
                )}
                <button onClick={() => handleDelete(index)}>X</button>
              </div>
            ))}
          </div>
          <button
            style={{ marginTop: "10px", width: "auto" }}
            onClick={handleUpload}
            disabled={isUploading}
            className="vendor_common_property"
          >
            {isUploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      ) : (
        <div className={styles.fileInputMedia}>
          <label>
            {multiple ? (
              <div>
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_7312_11251"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="21"
                  >
                    <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_7312_11251)">
                    <path
                      d="M9.375 10.6794L8.26438 11.7773C8.15035 11.8926 8.00778 11.9502 7.83667 11.9502C7.66569 11.9502 7.51819 11.8883 7.39417 11.7644C7.27347 11.649 7.21444 11.5026 7.21708 11.3254C7.21986 11.1481 7.27889 11.0017 7.39417 10.8863L9.47271 8.80771C9.6234 8.65701 9.79917 8.58167 10 8.58167C10.2008 8.58167 10.3766 8.65701 10.5273 8.80771L12.6058 10.8863C12.7211 11.0017 12.7822 11.1456 12.7892 11.3181C12.7961 11.4906 12.735 11.6396 12.6058 11.765C12.4904 11.88 12.3462 11.9383 12.1731 11.9398C12.0001 11.9415 11.8515 11.8846 11.7275 11.7692L10.625 10.6794V15.2435C10.625 15.3077 10.6517 15.3665 10.7052 15.4198C10.7585 15.4733 10.8173 15.5 10.8815 15.5H15.4167C16 15.5 16.4931 15.2986 16.8958 14.8958C17.2986 14.4931 17.5 14 17.5 13.4167C17.5 12.8333 17.2986 12.3403 16.8958 11.9375C16.4931 11.5347 16 11.3333 15.4167 11.3333H14.1667V9.66667C14.1667 8.51389 13.7604 7.53125 12.9479 6.71875C12.1354 5.90625 11.1528 5.5 10 5.5C8.84722 5.5 7.86458 5.90625 7.05208 6.71875C6.23958 7.53125 5.83333 8.51389 5.83333 9.66667H5.40063C4.61104 9.66667 3.93021 9.95139 3.35812 10.5208C2.78604 11.0903 2.5 11.7778 2.5 12.5833C2.5 13.3889 2.78472 14.0764 3.35417 14.6458C3.92361 15.2153 4.61111 15.5 5.41667 15.5H6.875C7.05208 15.5 7.20056 15.5599 7.32042 15.6798C7.44014 15.7997 7.5 15.9481 7.5 16.1252C7.5 16.3024 7.44014 16.4508 7.32042 16.5704C7.20056 16.6901 7.05208 16.75 6.875 16.75H5.41667C4.265 16.75 3.28264 16.3505 2.46958 15.5515C1.65653 14.7524 1.25 13.7759 1.25 12.6219C1.25 11.5866 1.58306 10.676 2.24917 9.89021C2.91528 9.10438 3.74139 8.63882 4.7275 8.49354C4.99458 7.24785 5.62097 6.22917 6.60667 5.4375C7.59222 4.64583 8.72333 4.25 10 4.25C11.5089 4.25 12.7889 4.77556 13.84 5.82667C14.8911 6.87778 15.4167 8.15778 15.4167 9.66667V10.0833H15.6731C16.5513 10.1517 17.2837 10.5048 17.8702 11.1427C18.4567 11.7805 18.75 12.5385 18.75 13.4167C18.75 14.3461 18.4295 15.134 17.7885 15.7804C17.1474 16.4268 16.3622 16.75 15.4327 16.75H10.8815C10.4605 16.75 10.1042 16.6042 9.8125 16.3125C9.52083 16.0208 9.375 15.6645 9.375 15.2435V10.6794Z"
                      fill="#009A50"
                    />
                  </g>
                </svg>
              </div>
            ) : (
              "Add a File"
            )}
          </label>
          <input
            type="file"
            accept={
              fileType === "image"
                ? "image/jpeg, image/png"
                : fileType === "video"
                ? "video/mp4, video/mov, video/avi, video/wmv, video/mkv"
                : "application/pdf"
            }
            multiple={multiple}
            onChange={handleFileChange}
          />
          {fileType === "image" && (
            <>
              <p>
                <span>Click to upload </span>or drag and drop
              </p>{" "}
              <p className="text-center my-5">JPG or PNG <br /> (max. 500x500px)</p>
            </>
          )}
          {fileType === "video" && (
            <p>or drop mp4, mov, avi, wmv, mkv videos here</p>
          )}
          {fileType === "document" && <p>or drop PDF documents here</p>}
          <div className={styles.selectFileType}>
            {/* <SelectBasicWithSelectTag
              disabled={true}
              label="Select File Type"
              name="upload_collection"
              value={fileType}
              onChange={(e) => setFileType(e.target.value)}
              options={getFieTypeArray(modelType)}
            /> */}
          </div>
        </div>
      )}
      {/* <hr /> */}
      <div>
        <div
          className="mt-10"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div>Uploaded Data:</div>
          <div style={{ width: "200px" }}>
            {/* <SelectBasicWithSelectTag
              label="Select File Type"
              name="upload_collection"
              value={showFileType}
              onChange={(e) => setShowFileType(e.target.value)}
              options={getFieTypeArrayShow(modelType)}
            /> */}
          </div>
        </div>
        <div>
          {/* {file_type_agent === "agent-logo" && (
            <ImageList
              imageData={imageData}
              deleteUrl={deleteType}
              fetchMediaRefetch={() =>
                fetchMedia({
                  modelType: modelType,
                  modelId: modelId,
                  upload_collection: file_type_agent ? file_type_agent : showFileType,
                })
              }
              multiple={multiple}
            />
          )} */}
          {showFileType === "image" && (
            <>
              {showSingleImage ? (
                <img src={imageData} />
              ) : (
                <ImageList
                  imageData={imageData}
                  deleteUrl={deleteType}
                  // fetchMediaRefetch={fetchMediaRefetch}
                  multiple={multiple}
                />
              )}
            </>
          )}

          {showFileType === "videos" && (
            <VideoList
              imageData={imageData}
              fetchMediaRefetch={() =>
                fetchMedia({
                  modelType: modelType,
                  modelId: modelId,
                  upload_collection: showFileType,
                })
              }
              multiple={true}
            />
          )}

          {showFileType === "photos" && (
            <>
              {showSingleImage ? (
                <>
                  {imageData && (
                    <div
                      style={{
                        width: "100px",
                        height: "100px",
                        textAlign: "center",
                        position: "relative",
                      }}
                    >
                      <img src={imageData} style={{ objectFit: "contain" }} />
                    </div>
                  )}
                </>
              ) : (
                <ImageList
                  imageData={imageData}
                  deleteUrl={deleteType}
                  fetchMediaRefetch={() =>
                    fetchMedia({
                      modelType: modelType,
                      modelId: modelId,
                      upload_collection: showFileType,
                    })
                  }
                  multiple={multiple}
                />
              )}
            </>
          )}

          {showFileType === "documents" && (
            <DocumentList
              documents={imageData}
              fetchMediaRefetch={() =>
                fetchMedia({
                  modelType: modelType,
                  modelId: modelId,
                  upload_collection: showFileType,
                })
              }
              multiple={multiple}
            />
          )}
        </div>
      </div>
      {/* <div style={{ marginTop: "10px" }}>
        <ImageList
          imageData={imageData}
          fetchMediaRefetch={fetchMediaRefetch}
        />
      </div> */}
    </div>
  );
};

export default MultipleImageUploadComponent;
